import React from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import he from 'he'
import {
	Row,
	Col,
	Pagination,
	Affix,
	Spin,
	Progress,
	Button,
	Alert,
	Icon,
	Badge,
	Dropdown,
	Menu,
	Input,
	Select,
	Checkbox,
	Slider,
	Card,
	message,
} from 'antd'

import apiPath from 'apiPath'
import moment from 'components/momentWithZone'
import stickyError from 'components/stickyError'
import sortByPortAndDay from 'components/sortByPortAndDay'
import ProgramCardList from '../ProgramCardList'
import loadFieldPrograms from '../loadFieldPrograms2'
import checkConflicts from '../checkConflicts'
import parseJSON from '../parseJSON'

const shoppingCartMenu = (items) => {
	return (
		<Menu>
			{items.map((item) => {
				return (
					<Menu.Item key={item.ExcursionId}>
						<span
							dangerouslySetInnerHTML={{ __html: item.Title }}
						/>
					</Menu.Item>
				)
			})}
			{items.length === 0 && <Menu.Item>Your cart is empty</Menu.Item>}
		</Menu>
	)
}

export default class Browse extends React.Component {
	state = {
		error: false,
		loading: false,
		page: 1,
		totalPrograms: 0,
		programs: [],
		cart: [],
		programImages: {},
		displayPageSize: 24,
		categories: [],
		inventory: {},
		inventoryLoaded: false,
		IDtoCode: {},
		portOrder: [],
		defaultFilters: {
			title: '',
			port: [],
			day: [],
			duration: [],
			category: [],
			price: [],
		},
		filters: {
			title: '',
			port: [],
			day: [],
			duration: [],
			category: [],
			price: [],
		},
		displayFilters: {
			title: '',
			port: [],
			day: [],
			duration: [],
			category: [],
			price: [],
		},
		maxPrice: 3000,
		loadProgress: 0,
		loadingImages: [],
		ports: [],
		eventCode: '',
	}

	// === Methods === //
	loadFieldProgramsIntoSessionstorage = () => {
		this.setState({ loading: true })

		if (this.props.booking.EventId === null) return

		this._interval = window.setInterval(() => {
			let speed = 0.01
			if (this.state.loadProgress + speed <= 0.12) {
				this.setState({ loadProgress: this.state.loadProgress + speed })
			}
		}, 300)

		loadFieldPrograms(this.props.booking.EventId, (progress) => {
			this.setState({ loadProgress: progress })
		})
			.then(() => {
				this.setState({ loading: false })
				this.getFieldPrograms(1)
				window.clearInterval(this._interval)
			})
			.catch((error) => {
				console.error(error)
				stickyError('Failed to load programs', 0, true)
			})
	}

	filterSelectOptions = (inputValue, option) => {
		const s =
			typeof option.props.children === 'string'
				? option.props.children
				: option.props.children.join(' ')
		return s.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1
	}

	// === Getters === //
	getCategories = () => {
		// only show a checkbox for GSCE
		this.setState({
			categories: [
				{ key: 'LeanIn', label: 'Lean In' },
				{ key: 'Strenuous', label: 'Strenuous' },
				{ key: 'FastPaced', label: 'Fast Paced' },
				{ key: 'Mobility1', label: 'Mobility - Level 1' },
				{ key: 'Mobility2', label: 'Mobility - Level 2' },
				{ key: 'Mobility3', label: 'Mobility - Level 3' },
				{ key: 'Mobility4', label: 'Mobility - Level 4' },
			],
		})
	}

	getInventory = () => {
		axios
			.get(apiPath + '/fieldprograms')
			.then((result) => {
				let inventory = {}
				let IDtoCode = {}
				let maxPrice = 0
				let todaydate = moment()

				result.data
					.sort((a, b) => {
						const aVal = a.isCurrentPrice ? 1 : 0
						const bVal = b.isCurrentPrice ? 1 : 0
						return aVal - bVal
					})
					.map((item) => {
						if (item.EventId !== this.props.booking.EventId)
							return null
						IDtoCode[item.ItemId] = item.Code
						const price = parseFloat(item.Price)
						const start = item.BegDate
						const end = item.EndDate

						var theitcenddate = moment(item.itcValidEndDate)
							.add(1, 'days')
						// .subtract(1, 'seconds')
						if (price > maxPrice) maxPrice = price
						//check if in inventory already
						if (inventory[item.Code] != null) {
							var inventoryitcEndDate =
								inventory[item.Code].itcValidEndDate

							// console.log(
							// 	item.Name,
							// 	theitcenddate,
							// 	inventoryitcEndDate
							// )

							//if the itcvalidate is in the future and its closer to today, or if the inventorydate is in the past
							if (
								todaydate.diff(
									theitcenddate.format(
										'YYYY-MM-DD HH:mm:ss.sss'
									)
								) < 0 &&
								(theitcenddate.diff(inventoryitcEndDate) < 0 ||
									todaydate.diff(inventoryitcEndDate) > 0)
							) {
								return (inventory[item.Code] = {
									ItemId: item.ItemId,
									Name: item.Name,
									available: parseInt(
										item.AvailItems,
										10
									).toString(),
									price: price,
									isCurrentPrice: item.isCurrentPrice,
									start: start,
									end: end,
									BegLocation: item.BegLocation,
									EndLocation: item.EndLocation,
									visible: item.Visible,
									bookable: item.Enabled,
									GSCE: item.GSCE,
									duration: item.Duration,
									itcValidBegDate: item.itcValidBegDate,
									itcValidEndDate: theitcenddate.format(
										'YYYY-MM-DD HH:mm:ss.sss'
									),
								})
							}
						} else {
							return (inventory[item.Code] = {
								ItemId: item.ItemId,
								Name: item.Name,
								available: parseInt(
									item.AvailItems,
									10
								).toString(),
								price: price,
								isCurrentPrice: item.isCurrentPrice,
								start: start,
								end: end,
								BegLocation: item.BegLocation,
								EndLocation: item.EndLocation,
								visible: item.Visible,
								bookable: item.Enabled,
								GSCE: item.GSCE,
								duration: item.Duration,
								itcValidBegDate: item.itcValidBegDate,
								itcValidEndDate: theitcenddate.format(
									'YYYY-MM-DD HH:mm:ss.sss'
								),
							})
						}
					})

				this.setState({
					inventory: inventory,
					inventoryLoaded: true,
					IDtoCode: IDtoCode,
					maxPrice: maxPrice,
				})
			})
			.catch(this.props.handleAxiosLoadError)
	}

	getCart = () => {
		this.setState({ cart: parseJSON(localStorage.fieldProgramCart, []) })
	}

	getFieldPrograms = async (page, filters) => {
		if (document.getElementsByClassName('ant-breadcrumb')[0]) {
			window.scrollTo(
				0,
				window.scrollY +
				document
					.getElementsByClassName('ant-breadcrumb')[0]
					.getBoundingClientRect().top
			)
		}
		let allPrograms = parseJSON(sessionStorage.fieldPrograms, [])

		allPrograms = allPrograms.filter((program) => {
			if (program.CruiseId)
				return (
					program.CruiseId === sessionStorage.fieldProgramsForVoyage
				)
			return false
		})

		if (filters) {
			if (filters.title) {
				allPrograms = allPrograms.filter((program) =>
					program.Title != null
						? he
							.decode(program.Title.toLowerCase())
							.indexOf(filters.title.toLowerCase()) !== -1
						: false || program.Summary != null
							? he
								.decode(program.Summary.toLowerCase())
								.indexOf(filters.title.toLowerCase()) !== -1
							: false || program.Description != null
								? he
									.decode(program.Description.toLowerCase())
									.indexOf(filters.title.toLowerCase()) !== -1
								: false || program.Code != null
									? he
										.decode(program.Code.toLowerCase())
										.indexOf(filters.title.toLowerCase()) !== -1
									: false
				)
			}
			if (filters.port.length) {
				allPrograms = allPrograms.filter(
					(program) =>
						filters.port.indexOf(program.Code.substring(0, 3)) !==
						-1
				)
			}
			if (filters.day.length) {
				allPrograms = allPrograms.filter(
					(program) =>
						program.StartDateTime &&
						filters.day.indexOf(
							'day-' +
							(moment(program.StartDateTime).diff(
								program.PortArrivalTime,
								'days'
							) +
								1)
						) !== -1
				)
			}
			if (filters.duration.length) {
				allPrograms = allPrograms.filter(
					(program) =>
						!this.state.inventory[program.Code] ||
						(this.state.inventory[program.Code].duration &&
							filters.duration.indexOf(
								this.state.inventory[program.Code].duration
							) !== -1)
				)
			}
			if (filters.category.length) {
				let mobilities = [];
				const isLeanIn = filters.category.indexOf('LeanIn') !== -1
				const isStrenuous = filters.category.indexOf('Strenuous') !== -1
				const isFastPaced = filters.category.indexOf('FastPaced') !== -1
				const isMobility1 = filters.category.indexOf('isMobility1') !== -1

				if (filters.category.indexOf('Mobility1') !== -1) {
					mobilities.push("1");
				}
				if (filters.category.indexOf('Mobility2') !== -1) {
					mobilities.push("2");
				}
				if (filters.category.indexOf('Mobility3') !== -1) {
					mobilities.push("3");
				}
				if (filters.category.indexOf('Mobility4') !== -1) {
					mobilities.push("4");
				}

				console.log(mobilities);

				allPrograms = allPrograms.filter((program) => {
					if (
						(isLeanIn && program.IsLeanIn) ||
						(isStrenuous && program.IsStrenuous) ||
						(isFastPaced && program.IsFastPaced) ||
						(mobilities.length > 0 && mobilities.indexOf(program.physical_activity_level) !== -1)
					) {
						return true
					}

					return false
				})
			}
			if (filters.price.length) {
				allPrograms = allPrograms.filter(
					(program) =>
						!this.state.inventory[program.Code] ||
						(filters.price[0] <=
							this.state.inventory[program.Code].price &&
							this.state.inventory[program.Code].price <=
							filters.price[1])
				)
			}
		}

		allPrograms = allPrograms.sort(sortByPortAndDay(this.state.portOrder))

		this.setState({
			totalPrograms: allPrograms.length,
			programs: this.props.noPagination
				? allPrograms
				: allPrograms.slice(
					(page - 1) * this.state.displayPageSize,
					page * this.state.displayPageSize
				),
		})
	}

	getPorts = async () => {
		if (!this.props.booking.EventId) return

		try {
			const response = await fetch(
				`${apiPath}/voyages/${this.props.booking.EventId}/ports`
			)

			if (!response.ok) {
				throw new Error(response.statusText)
			}

			const ports = await response.json()
			const portOrder = ports.map((port) => port.portCode)

			this.setState({ ports, portOrder })
		} catch (error) {
			console.error(error)
		}
	}

	// === Handle Change Events === //
	handleFilterChange = (filter) => {
		let newFilters = Object.assign({}, this.state.filters, filter)
		this.setState({ page: 1, displayFilters: newFilters })
	}

	handleFilterSelectChange = (filter) => {
		let newFilters = Object.assign({}, this.state.filters, filter)
		this.getFieldPrograms(1, newFilters)
		this.setState({
			page: 1,
			displayFilters: newFilters,
			filters: newFilters,
		})
	}

	handleFilterBlur = () => {
		let newFilters = Object.assign({}, this.state.displayFilters)
		this.getFieldPrograms(1, newFilters)
		this.setState({ page: 1, filters: newFilters })
	}

	handleFilterClear = () => {
		let newFilters = Object.assign({}, this.state.defaultFilters, {
			price: [0, this.state.maxPrice],
		})
		this.setState({
			page: 1,
			displayFilters: newFilters,
			filters: newFilters,
		})
		this.getFieldPrograms(1, newFilters)
	}

	handlePageChange = (page, pageSize) => {
		this.getFieldPrograms(page, this.state.filters)
		this.setState({ page: page })
	}

	handleAddToCart = (program) => {
		this.props
			.refreshBooking()
			.then((result) => {
				checkConflicts(
					program,
					this.state.inventory,
					this.state.cart,
					this.props.bookedItems,
					this.state.IDtoCode
				)
					.then((result) => {
						localStorage.setItem(
							'fieldProgramCart',
							JSON.stringify(this.state.cart.concat(program))
						)
						this.setState({ cart: this.state.cart.concat(program) })
						message.success(
							he.decode(program.Title) + ' was added to your cart'
						)
					})
					.catch((error) => {
						if (error.message) {
							console.error(error)
							stickyError(error.message, 0, true)
						} else {
							const conflict = error
							console.error(conflict)
							stickyError(conflict, 0, false, 'Conflict')
						}
					})
			})
			.catch((error) => {
				console.error(error)
				if (error.response.status === 403) this.props.kickSession()
			})
	}

	handleImageLoadAttempt = (trip_code) => {
		let newLoadingImages = this.state.loadingImages.slice()
		if (newLoadingImages.indexOf(trip_code) === -1) {
			newLoadingImages.push(trip_code)
			this.setState({ loadingImages: newLoadingImages })
		}
	}

	handleImageLoadSuccess = (trip_code) => {
		const i = this.state.loadingImages.indexOf(trip_code)
		if (i !== -1) {
			let newLoadingImages = this.state.loadingImages.slice(i, i + 1)
			this.setState({ loadingImages: newLoadingImages })
		}
	}

	startPageHeightReporting = () => {
		window.setInterval(function () {
			let height = document.getElementById('root').offsetHeight
			parent.postMessage(height, '*')
		}, 1000)
	}

	// === LIFECYCLE METHODS === //
	async componentWillMount() {
		window.moment = moment
		this.getPorts()

		if (
			!sessionStorage.fieldProgramsUpdated ||
			!sessionStorage.fieldProgramsForVoyage ||
			moment(sessionStorage.fieldProgramsUpdated, 'X')
				.add(1, 'hours')
				.isBefore(moment()) ||
			sessionStorage.fieldProgramsForVoyage !==
			(this.props.booking.EventId || this.props.booking.TripCode)
		) {
			this.loadFieldProgramsIntoSessionstorage()
		} else {
			this.getFieldPrograms(1, this.state.filters)
		}

		this.getCart()
		this.getCategories()
		this.getInventory()
	}

	componentDidMount() {
		if (window.top !== window.self) this.startPageHeightReporting()
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.booking.EventId !== this.props.booking.EventId ||
			prevProps.booking.TripCode !== this.props.booking.TripCode
		) {
			this.getPorts()
			this.loadFieldProgramsIntoSessionstorage()
			this.getCart()
			this.getCategories()
			this.getInventory()
		}
	}

	// === RENDER === //
	render() {
		const disabled =
			this.props.variant !== 'admin' &&
			typeof this.props.sectionIsEnabled === 'function' &&
			!this.props.sectionIsEnabled(this.props, 'field/browse')
		if (this.props.variant !== 'admin' && this.props.redirectIfHidden) {
			const redirect = this.props.redirectIfHidden(
				this.props,
				'field/browse'
			)
			if (redirect) return redirect
		}
		const rule =
			this.props.configRules &&
			this.props.configRules.find(
				(rule) =>
					rule.section === 'field/browse' &&
					rule.voyage === this.props.booking.EventId
			)
		const fieldProgramsOpen = !rule
			? false
			: rule.enableAlways === '1'
				? true
				: moment().isBetween(
					moment.utc(rule.enableFrom),
					moment.utc(rule.disableAfter)
				)
		const deadlinePassed = !rule
			? false
			: rule.enableAlways === '1'
				? false
				: moment().isAfter(moment.utc(rule.disableAfter))
		const filterColumnProps = {
			xs: 24,
			sm: 12,
			md: 8,
			style: { padding: '4pt' },
		}
		const noTopBanners =
			typeof this.props.noTopBanners !== 'undefined'
				? this.props.noTopBanners
				: false

		const shouldShowSpotsLeft =
			typeof this.props.showSpotsLeft !== 'undefined'
				? this.props.showSpotsLeft && fieldProgramsOpen
				: this.props.variant === 'admin'
					? true
					: fieldProgramsOpen
		let priceRange = { 0: '$0' }
		priceRange[this.state.maxPrice] = '$' + this.state.maxPrice
		let colClassNames = ['programCardCol']
		if (shouldShowSpotsLeft) colClassNames.push('taller')

		const programsMissingRescoData = this.state.programs.filter(
			(program) =>
				program.Code !== '-' &&
				Object.keys(this.state.inventory).length &&
				!this.state.inventory[program.Code]
		)

		return (
			<div>
				{!noTopBanners && (
					<div>
						{!this.state.loading && this.state.error && (
							<Alert
								message='Error'
								description={this.state.error}
								type='error'
								showIcon
							/>
						)}
						<br />
					</div>
				)}

				<Row style={{ background: '#ececec', padding: '4pt' }}>
					{/* Search */}
					<Col {...filterColumnProps}>
						<Input.Search
							placeholder='Search'
							size='large'
							value={this.state.displayFilters.title || ''}
							onChange={(event) =>
								this.handleFilterChange({
									title: event.target.value,
								})
							}
							onBlur={this.handleFilterBlur}
							onSearch={this.handleFilterBlur}
						/>
					</Col>

					{/* Port Filter */}
					<Col {...filterColumnProps}>
						<Select
							allowClear
							placeholder='Port'
							mode='multiple'
							size='large'
							style={{ width: '100%' }}
							value={this.state.displayFilters.port}
							filterOption={this.filterSelectOptions}
							onChange={(value) =>
								this.handleFilterSelectChange({ port: value })
							}
						>
							{this.state.ports &&
								this.state.ports.map((port) => (
									<Select.Option key={port.portCode}>
										{`${port.portName}, ${port.country}`}
									</Select.Option>
								))}
						</Select>
					</Col>

					{/* Start Day Filter */}
					<Col {...filterColumnProps}>
						<Select
							allowClear
							placeholder='Start day'
							mode='multiple'
							size='large'
							style={{ width: '100%' }}
							value={this.state.displayFilters.day}
							filterOption={this.filterSelectOptions}
							onChange={(value) =>
								this.handleFilterSelectChange({ day: value })
							}
						>
							{[1, 2, 3, 4, 5, 6].map((day) => (
								<Select.Option key={'day-' + day}>
									Day {day}
								</Select.Option>
							))}
						</Select>
					</Col>

					{/* Duration Filter */}
					<Col {...filterColumnProps}>
						<Select
							allowClear
							placeholder='Duration'
							mode='multiple'
							size='large'
							style={{ width: '100%' }}
							value={this.state.displayFilters.duration}
							filterOption={this.filterSelectOptions}
							onChange={(value) =>
								this.handleFilterSelectChange({
									duration: value,
								})
							}
						>
							{['Day', 'Overnight'].map((duration) => (
								<Select.Option key={duration}>
									{duration + ' Programs'}
								</Select.Option>
							))}
						</Select>
					</Col>

					{/* Category Filter */}
					<Col {...filterColumnProps}>
						{this.state.categories.length === 1 ? (
							<div style={{ padding: '4pt' }}>
								<Checkbox
									onChange={(e) => {
										if (e.target.checked)
											this.handleFilterSelectChange({
												category: [
													this.state.categories[0]
														.key,
												],
											})
										else
											this.handleFilterSelectChange({
												category: [],
											})
									}}
									checked={
										this.state.filters.category.length > 0
									}
								>
									{this.state.categories[0].label}
								</Checkbox>
							</div>
						) : (
							<Select
								placeholder='Category'
								mode='multiple'
								size='large'
								style={{ width: '100%' }}
								value={this.state.displayFilters.category}
								onChange={(value) =>
									this.handleFilterSelectChange({
										category: value,
									})
								}
							>
								{this.state.categories.map((category) => (
									<Select.Option key={category.key}>
										{category.label}
									</Select.Option>
								))}
							</Select>
						)}
					</Col>

					{/* Price Filter */}
					<Col {...filterColumnProps}>
						<div style={{ padding: '0 8pt 0 3pt' }}>
							<Slider
								range
								min={0}
								max={this.state.maxPrice}
								step={10}
								marks={priceRange}
								tipFormatter={(value) => '$' + value}
								value={
									this.state.displayFilters.price.length
										? this.state.displayFilters.price
										: [0, this.state.maxPrice]
								}
								onChange={(value) =>
									this.handleFilterChange({ price: value })
								}
								onAfterChange={this.handleFilterBlur}
								onBlur={this.handleFilterBlur}
							/>
						</div>
					</Col>

					{/* Clear */}
					<span style={{ float: 'right' }}>
						<Button onClick={this.handleFilterClear}>
							Clear all filters
						</Button>
					</span>
				</Row>

				<Affix target={() => window}>
					<div style={{ background: '#ececec', padding: '4pt' }}>
						{!deadlinePassed && fieldProgramsOpen && (
							<div>
								<div
									style={{
										display: 'inline-block',
										float: 'right',
										margin: '4pt',
										marginLeft: '8pt',
									}}
								>
									<Link to='/portal/field/Checkout'>
										<Button
											type='primary'
											disabled={
												this.state.cart.length === 0
											}
										>
											Check Out
										</Button>
									</Link>
								</div>
								<div
									style={{
										display: 'inline-block',
										float: 'right',
										margin: '4pt',
									}}
								>
									<Dropdown
										overlay={shoppingCartMenu(
											this.state.cart
										)}
										placement='bottomRight'
									>
										<Badge count={this.state.cart.length}>
											<Icon
												type='shopping-cart'
												style={{ fontSize: '2.2em' }}
											/>
										</Badge>
									</Dropdown>
								</div>
							</div>
						)}
						{!this.props.noPagination && (
							<Pagination
								defaultCurrent={1}
								defaultPageSize={24}
								current={this.state.page}
								total={this.state.totalPrograms}
								onChange={this.handlePageChange}
								showTotal={(total, range) =>
									range[0] + '-' + range[1] + ' of ' + total
								}
							/>
						)}
					</div>
					{this.state.loading && !this.state.error && (
						<div style={{ textAlign: 'center' }}>
							<Spin />
							<br />
							<br />
							<Progress
								status='active'
								percent={Math.round(
									this.state.loadProgress * 100
								)}
							/>
						</div>
					)}
				</Affix>

				{!this.state.loading && this.state.programs.length === 0 ? (
					<Alert
						showIcon
						type='error'
						message='No matching programs found'
					/>
				) : (
					<ProgramCardList
						programs={this.state.programs}
						booking={this.props.booking}
						bookedItems={this.props.bookedItems}
						cart={this.state.cart}
						inventory={this.state.inventory}
						shouldShowCartButtons={
							!this.props.noCartButtons &&
							fieldProgramsOpen &&
							!deadlinePassed
						}
						cardProps={{
							loading: this.state.inventoryLoaded !== true,
							onCartAdd: this.handleAddToCart,
							showPrice: true,
							showSpotsLeft: shouldShowSpotsLeft,
							showBanners:
								typeof this.props.showBanners !== 'undefined'
									? this.props.showBanners
									: true,
							onImageLoadAttempt: this.handleImageLoadAttempt,
							onImageLoadSuccess: this.handleImageLoadSuccess,
							loadingOtherImages: this.state.loadingImages.length,
						}}
					/>
				)}

				{this.props.variant === 'admin' && (
					<Row>
						{programsMissingRescoData.length > 0 && (
							<Col span={24} style={{ marginTop: '16pt' }}>
								<h2>Missing Resco Data</h2>
								<hr />
							</Col>
						)}

						{programsMissingRescoData.map((program) => {
							return (
								<div key={program.slug}>
									<Col
										xs={24}
										sm={12}
										md={8}
										xl={6}
										style={{ padding: '4pt' }}
									>
										<Card className='programCard'>
											<a
												target='_blank'
												href={program.link}
											>
												{program.Code}
											</a>
										</Card>
									</Col>
								</div>
							)
						})}
					</Row>
				)}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./portal-components/Portal/FieldPrograms/Browse/index.jsx